import { Injectable } from '@angular/core';
import { Logger } from '@common/logging/logger';
import { QueryService } from '@services/query/query.service';
import { MedicalOrderNodeValue } from 'src/app/shared/models/medical-order/medical-order-node-value';
import { MedicalOrderRequestDto } from 'src/app/shared/models/medical-order/medical-order-request-dto.model';
import { DoctorHandler } from '../../prescription/prescription-chain/prescription-chain-doctor-handler';
import { PatientHandler } from '../../prescription/prescription-chain/prescription-chain-patient-handler';
import { PayerHandler } from '../../prescription/prescription-chain/prescription-chain-payer-handler';
import { CreatePlainMedicalOrder } from './medical-order-chain-create-plain-medical-order-handler';

export interface IMedicalOrderChain {
  handleRequest(medicalOrderRequestDto: MedicalOrderRequestDto, request: MedicalOrderNodeValue);
}

@Injectable({ providedIn: 'root' })
export class MedicalOrderChain implements IMedicalOrderChain {
  constructor(
    private _queryService: QueryService,
    private _logger: Logger
  ) {}

  handleRequest(medicalOrderRequestDto: MedicalOrderRequestDto, request: MedicalOrderNodeValue) {
    const createPlainMedicalOrderHandler = new CreatePlainMedicalOrder();
    const doctorHandler = new DoctorHandler(this._queryService);
    const patientHandler = new PatientHandler(this._queryService, this._logger);
    const payerHandler = new PayerHandler(this._queryService);

    createPlainMedicalOrderHandler
      .setNext(doctorHandler)
      .setNext(patientHandler)
      .setNext(payerHandler)
      .handleRequest(medicalOrderRequestDto, request);

    return createPlainMedicalOrderHandler.handleRequest(medicalOrderRequestDto, request);
  }
}
